import { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { DropdownCard } from 'shared/ui'
import type { Contact } from 'entities/Contacts/model/Contact'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ChatbotEnrollStore } from 'widgets/ChatbotEnroll/store/ChatbotEnrollStore'

import styles from './styles.module.scss'

type IContactEnrollDropdownItemProps = {
  contact: Contact
  onClick: () => void
}

export const ContactEnrollDropdownItem = observer(
  ({ contact, onClick }: IContactEnrollDropdownItemProps) => {
    const entities = useEntitiesContext()
    const store = useMemo(() => new ChatbotEnrollStore(entities), [])
    const blockReason = store.getBlockReason(contact)

    useEffect(() => store.checkActivity(), [])

    if (!store.isOperationEnabled) return null

    return (
      <DropdownCard
        item={{
          id: 'chatbot',
          label: 'Engage with AI Agent',
          iconL: 'chatBot',
          disabled: !!blockReason,
          tooltipProps: {
            placement: 'left-start',
            label: blockReason,
            className: styles.tooltip,
          },
        }}
        onChange={() => {
          onClick()
          store.enrollContacts([contact.id])
        }}
      />
    )
  }
)
